<script lang="ts">
import { ChartOptions } from "chart.js";
import { Bar, mixins } from "vue-chartjs";
import { Component, Mixins } from "vue-property-decorator";
import "chartjs-plugin-datalabels";
import i18n from "@/i18n";

@Component({
  extends: Bar,
  mixins: [mixins.reactiveProp],
})
export default class PhonesGraphBar extends Mixins(mixins.reactiveProp, Bar) {
  options: ChartOptions = {
    legend: {
      display: false,
    },
    layout: {
      padding: 0,
    },
    scales: {
      yAxes: [
        {
          position: i18n.locale === "he-IL" ? "right" : "left",
          gridLines: {
            // display: false,
          },
          ticks: {
            suggestedMin: 0,
            // suggestedMax: 100,
            callback: function (value: number): string {
              if (value > 1000) {
                return Number((value / 1000).toString()) + "K";
              } else {
                return value + "";
              }
            },
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            padding: 10
          }
        },
      ],
    },
    responsive: true,
    maintainAspectRatio: false,
    responsiveAnimationDuration: 0,
    plugins: {
      datalabels: {
        anchor: "end",
        align: "end",
        textAlign: "center",
        color: "#333",
        offset: -25,
        clip: false,
        formatter: function (context) {
          if (context > 1000) {
            return context / 1000 + "K";
          }
        },
      },
    },
  };

  mounted(): void {
    this.refreshChart();
  }

  refreshChart(): void {
    if (!this.$refs.canvas) {
      return;
    }
    this.renderChart(this.chartData, this.options);
  }
}
</script>
